import styled from 'styled-components';

export const HeroP2 = styled.p`
  margin-top: 20px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  max-width: 600px;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
`;

export const Input = styled.input`
  font-size: 20px;
  width: 60px;
  border: none;
  border-radius: 10px;
  text-align: center;
  height: 24px;
  color: #864c00;
    
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
    height: 18px;
  }
`

export const HeroBtnWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MintButton = styled.button`
  border-radius: 50px;
  background: #05c865;
  white-space: nowrap;
  padding: 10px 45px;
  color: #fff;
  font-size: 16px;
  outline: none;
  border: solid 3px #fff;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #000;
    color: #fff;
    border: solid 3px #fff;
  }

  &:active {
    background: #fff;
    color: #000;
    border: solid 3px #000;
  }
`;